let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dTqLa")).then(() => parcelRequire('gkJYm'));